import { PHONE, PHONE_HREF, SMS_HREF } from "../../lib/erg";
import { Phone, MessageSquare } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-erg-ink text-erg-dry">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-[1.2fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-8 w-8 rounded-[6px] bg-erg-aqua/15 border border-erg-aqua/40">
                <span className="h-2.5 w-2.5 rounded-full bg-erg-aqua" />
              </span>
              <span className="font-display font-bold uppercase tracking-wide text-lg">
                Emergency Response Group
              </span>
            </div>
            <p className="mt-4 text-erg-dry/60 leading-relaxed max-w-md">
              Water, fire, and emergency restoration across Canada, with limited US coverage.
              Water and flood damage, fuel and chemical spills, and biohazard cleanup.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-erg-aqua/70">
              Reach us anytime
            </span>
            <a
              data-testid="footer-phone-link"
              href={PHONE_HREF}
              className="inline-flex items-center gap-2 font-display font-semibold text-2xl hover:text-erg-ember transition-colors"
            >
              <Phone className="h-5 w-5" /> {PHONE}
            </a>
            <a
              data-testid="footer-sms-link"
              href={SMS_HREF}
              className="inline-flex items-center gap-2 text-erg-dry/70 hover:text-erg-aqua transition-colors"
            >
              <MessageSquare className="h-4 w-4" /> Text us — same number
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 space-y-3">
          <p className="text-erg-dry/45 text-sm leading-relaxed max-w-3xl">
            We document the water source and the damage. We do not advise on what your policy
            covers or whether you'll be reimbursed — those questions belong with your
            declarations page and your broker. Foundation waterproofing and source-control
            dewatering are outside our scope; we refer those out.
          </p>
          <p className="font-mono text-[11px] tracking-wide text-erg-dry/35">
            © {new Date().getFullYear()} Emergency Response Group. Available 24/7.
          </p>
        </div>
      </div>
    </footer>
  );
};
